export default __webpack_public_path__ + "images/7068e937-familia.svg";